<template>
  <div
    class="text-left flex-grow-1 comment pointer"
    v-if="lastComment"
    :title="commentText"
    @click="$emit('open-event', $event)"
  >
    <b class="text-prime">{{ actorName }},</b>
    <span>{{ commentDate }}</span
    >:
    <span>{{ commentText }}</span>
  </div>
  <div
    class="add-comment flex-grow-1 text-secondary pointer text-left"
    @click="$emit('add-comment')"
    v-else
  >
    <div class="add-comment-button">Add a comment</div>
  </div>
</template>

<script>
import { localizedDateString } from '@/datetime'
import convertHTMLToPlainText from '@/utils/convertHTMLToPlainText'

/**
 * This displays last comment on the initiative along with commenter's first name.
 */
export default {
  name: 'LastCommentTableCell',
  props: ['lastComment'],
  data() {
    return {
      actorName: null
    }
  },
  computed: {
    commentDate() {
      if (!this.lastComment) return
      return localizedDateString(new Date(this.lastComment.updatedAt))
    },
    commentText() {
      const comment = this.lastComment.comment
      return convertHTMLToPlainText(comment)
    }
  },
  methods: {
    async refreshActorName() {
      if (!this.lastComment) return
      const actor = await this.$store.dispatch('getUser', { id: this.lastComment.actorId })
      this.actorName = actor.firstName
    }
  },
  mounted() {
    this.refreshActorName()
  },
  watch: {
    lastComment: 'refreshActorName'
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.comment {
  @include lineClamp(2);
}
.add-comment-button {
  opacity: 0;
  transition: opacity 100ms ease-in;
}
.add-comment:hover .add-comment-button {
  opacity: 1;
}
</style>
